export default {
  email: '',
  password: '',
  name: '',
  userId: '',
  loading: false,
  token: '',
  views: []
}
